import React, { useState } from 'react';
import './HomeBanners.css';
import { Swiper } from "swiper/react";
import { SwiperSlide } from "swiper/react";
import SwiperCore from 'swiper';
import { Autoplay, EffectFade, Navigation, Pagination } from "swiper";
import { GrFormPrevious, GrFormNext } from 'react-icons/gr';
import { UilFacebookF } from '@iconscout/react-unicons'
// import { UilTwitter } from '@iconscout/react-unicons'
// import { UilInstagramAlt } from '@iconscout/react-unicons'
// import { UilLinkedin } from '@iconscout/react-unicons'

SwiperCore.use([Navigation]);

const HomeBanners = (props) => {
    // const [banners, setBanners] = useState([])

    // useEffect(() => {
    //     fetch('HomeBanner.json')
    //         .then(res => res.json())
    //         .then(data => setBanners(data))
    // }, [])
    const [swiperRef, setSwiperRef] = useState(null);

    const prevHandler = () => {
        swiperRef.slidePrev();
    };

    const nextHandler = () => {
        swiperRef.slideNext();
    };
    return (
        < >   <Swiper
            slidesPerGroup={1} loop={true} loopFillGroupWithBlank={true}
            effect={"fade"}
            spaceBetween={50} onSwiper={(swiper) => setSwiperRef(swiper)}
            navigation={false}
            autoplay={{
                delay: 2500,
                disableOnInteraction: false,
            }}

            modules={[EffectFade, Navigation, Pagination, Autoplay]}
            className="mySwiper"
        >

            {
                props.props.banner.map(banner =>
                    <SwiperSlide key={banner.serial}>
                        <img src={banner.img} className="bannerImg" alt="" />
                    </SwiperSlide>)
            }

        </Swiper>
            <div  >
                <p className='icon-badge3'><span >
                    <UilFacebookF size="13" />
                </span>
                </p>
                {/* <p className='icon-badge2'><span >
                    <UilTwitter size="13" />
                </span>
                </p>
                <p className='icon-badge3'><span >
                    <UilInstagramAlt size="13" />
                </span>
                </p>
                <p className='icon-badge4'><span >
                    <UilLinkedin size="13" />
                </span>
                </p> */}

            </div>
            <GrFormPrevious onClick={prevHandler} className="bannerBtnPrev" size={50} />
            <GrFormNext onClick={nextHandler} className="bannerBtnNext" size={50} />
        </>
    );
};

export default HomeBanners;